import { AxiosPromise } from "axios";
import { get } from "@/application/api";
import {
  MetaTenantAdminShowResource,
  MetaTenantWebsiteShowResource,
} from "@/modules/shared/meta/types";

export const fetchMeta = (
  config?: object,
): AxiosPromise<{
  data: MetaTenantAdminShowResource | MetaTenantWebsiteShowResource;
}> => {
  return get("meta", config);
};
